import React, { useState, useCallback, useContext, useEffect } from "react";
import ItemLibrary from "../ItemLibrary/ItemLibrary";
import ModalDetail from "../ModalDetail/ModalDetail";
import { FormattedMessage, injectIntl } from "react-intl";
import { AuthenticationContext } from "../AuthenticationContextProvider";
import { ConfigContext } from "../ConfigContextProvider";

import Spinner from "../../icon/three-dots.svg";

const Favorites = (props) => {
  const { favorites, setFavorites, userOptions, apps } = useContext(
    AuthenticationContext
  );
  const [detail, setDetail] = useState(null);
  const [modalIsOpen, setIsOpen] = React.useState(false);

  const [message, setMessage] = useState("");

  const { SAVE_FAVORITES_URL } = useContext(ConfigContext);
  const { APPID } = useContext(ConfigContext);
  const numberFavorites = userOptions.numberFavorites || 5;

  const canRequestSamples = apps?.samples?.request !== false;

  //const [requestAlreadySent, setRequestAlreadySent]  = useState(localStorage.getItem("samplesSent"));
  const parseRequestDisable = (value) =>
    (value ==="true") ? true : (value ==="false")? false : value;
  const [requestAlreadySent, setRequestAlreadySent] = useState(
    parseRequestDisable(userOptions.requestDisable)
  );

  // userOptions cambia dopo il login: riallinea lo stato
  useEffect(() => {
    setRequestAlreadySent(parseRequestDisable(userOptions.requestDisable));
  }, [userOptions.requestDisable]);
  const [requestLoading, setRequestLoading] = useState(false);
  const [requestSuccess, setRequestSuccess] = useState(false);

  const closeModal = useCallback(() => {
    setIsOpen(false);
    setDetail(null);
  });

  const isFavorite = useCallback((obj) => {
    const filtered = favorites.filter((item) => item.name === obj.name);
    return filtered.length > 0;
  });

  const onRequestLogin = useCallback(() => {
    //const event = new Event('login');
    //document.dispatchEvent(event);
   
    const event = new CustomEvent("login", { detail: { APPID: APPID, fMode: "LOGIN",namespace:"modalAuth" } });
    document.dispatchEvent(event);
  });

  const toggleFavorite = useCallback((obj) => {
    let updateFavorites = [...favorites];
    const filtered = favorites.filter((item) => item.name === obj.name);
    if (filtered.length > 0) {
      updateFavorites = favorites.filter((item) => item.name !== obj.name);
    } else {
      updateFavorites.push(obj);
    }
    setFavorites(updateFavorites);
    localStorage.setItem("favorites", JSON.stringify(updateFavorites));
  });

  //const {items, currentSelected} = props;
  const openDetailHandler = useCallback((detail) => {
    setDetail(detail);
    setIsOpen(true);
  });

  const sendSampleHandler = useCallback(() => {
    //if(!userOptions) {
    if (!userOptions.login || userOptions.login === "0") {
      const event = new CustomEvent("login", { detail: { APPID: APPID, fMode:"LOGIN",namespace:"modalAuth" } });
      document.dispatchEvent(event);

      // const event = new Event('login');
      // document.dispatchEvent(event);
    } else {
      setRequestLoading(true);
      //console.log(SAVE_FAVORITES_URL, MODE)

      //save favorites
      const param = {
        favorites: favorites,
        message: message,
        appid: APPID,
        ...userOptions,
      };
      const options = {
        method: "POST",
        body: JSON.stringify(param),
        headers: {
          "Content-Type": "application/json",
        },
      };
      let obj= {
        event: 'send_request_sample',
        category: favorites.map(item => item.name.split(" ").pop()).join('|'),
        option: favorites.length
      };

      //action: props.type,
      //label: props.category,



      window.sendToGTM && window.sendToGTM(obj)

      //fetch(SAVE_FAVORITES_URL, (MODE=="dev") ? {} : options )
      fetch(SAVE_FAVORITES_URL, options)
        .then((res) => res.json())
        .then(
          () => {
            setRequestLoading(false);
            setRequestSuccess(true);
            localStorage.setItem("samplesSent", true);
          },
          () => {
            setRequestLoading(false);
            setRequestAlreadySent(false);
          }
        );
      }
  });

  //console.log(requestAlreadySent, "-----> requestAlreadySent")
  const isSentSuccess = requestSuccess && !requestLoading && !requestAlreadySent;
  return (
    <>
      <div className="favoritesSummary">
        <div className="container">
        <div className="favoritesSummary__textContainer">
          <h2 className="favoritesSummary__title">
            <FormattedMessage id={"label.samples.title"} />
          </h2>
          <p className="favoritesSummary__description">
            <FormattedMessage id={"label.samples.description"} />
          </p>
          <p className="favoritesSummary__note">
            <FormattedMessage id={"label.samples.note"} />
          </p>
          <p
            className="HomePage__terms"
            dangerouslySetInnerHTML={{
              __html: props.intl.formatMessage({ id: "terms.description" }),
            }}
          />
        </div>
        
        <div className="library__wrapper">
          <div className="library__container">
            <>
              <div className="favoritesSummary__listWrapper">
                <ul className="libraryList">
                  {favorites &&
                    favorites.map((item, i) => {
                      let isFavoriteItem = isFavorite(item);
                      let isDisabled =
                        !isFavoriteItem && favorites.length > numberFavorites;
                      return (
                        <ItemLibrary
                          toggleFavorite={toggleFavorite}
                          disabled={isDisabled}
                          favorite={isFavoriteItem}
                          key={item.name + "_" + i}
                          item={item}
                          onClick={openDetailHandler}
                        />
                      );
                    })}
                  {[...Array(numberFavorites - favorites.length).keys()].map((_, index) => {
                    return (
                      <li key={index} className="itemLibrary">
                        <div className="itemLibrary__imgWrappper">
                          <div className="itemLibrary__btnDetail"></div>
                        </div>
                      </li>
                    );
                  })}
                </ul>
              </div>
              <div className="favoritesSummaryFooter">
              
                {!requestAlreadySent && !isSentSuccess && canRequestSamples && (
                  <h3 className="favoritesSummaryFooter__title">
                    <FormattedMessage id={"favorites.send.title"} />
                  </h3>
                )}

                {(!userOptions.login || userOptions.login === "0") && (
                  <>
                    <p className="favoritesSummaryFooter__description">
                      <FormattedMessage
                        id={"favorites.send.login.description"}
                      />
                    </p>
                    <div className="favoritesSummaryFooter__wrapperSendButton">
                      <button
                        className={
                          "favoritesSummary__btn favoritesSummary__btn--footer"
                        }
                        onClick={onRequestLogin}
                      >
                        <FormattedMessage id={"favorites.login.button"} />
                      </button>
                    </div>
                  </>
                )}

                {userOptions.login && userOptions.login === "1" && (
                  <>
                    {!requestSuccess && requestLoading && requestAlreadySent && (
                      <p className="favoritesSummaryFooter__description">
                        <FormattedMessage id={"favorites.send.description"} />
                      </p>
                    )}
                    <div className="favoritesSummaryFooter__wrapperSendButton">
                      {requestLoading && <img src={Spinner} />}

                      {requestAlreadySent && (
                        <p>
                          <FormattedMessage
                            id={"favorites.sent.already.description"}
                          />
                        </p>
                      )}

                      {isSentSuccess && (
                        <p>
                          <FormattedMessage id={"favorites.send.success"} />
                        </p>
                      )}

                      {!requestLoading &&
                        !requestAlreadySent &&
                        !requestSuccess && (
                          <div>
                            {!canRequestSamples ? (
                              <>
                                <h3 className="favoritesSummaryFooter__title">
                                  <FormattedMessage id={"favorites.no.permission.title"} />
                                </h3>
                                <p
                                  className="favoritesSummaryFooter__description"
                                  dangerouslySetInnerHTML={{ __html: props.intl.formatMessage({ id: "favorites.no.permission.description" }) }}
                                />
                              </>
                            ) : (
                              <>
                                <p className="favoritesSummaryFooter__description">
                                  <FormattedMessage
                                    id={"favorites.send.request.description"}
                                  />
                                </p>
                                <div className="favoritesSummary__requestWrapper">
                                  <textarea
                                    maxlength="800"
                                    placeholder={props.intl.formatMessage({
                                      id: "placeholder.textarea.request",
                                    })}
                                    className="favoritesSummary__textarea"
                                    value={message}
                                    onChange={(e) => setMessage(e.target.value)}
                                  />
                                </div>
                                <button
                                  disabled={favorites.length === 0}
                                  className={
                                    "favoritesSummary__btn favoritesSummary__btn--footer"
                                  }
                                  onClick={sendSampleHandler}
                                >
                                  <FormattedMessage id={"favorites.send.request"} />
                                </button>
                              </>
                            )}
                          </div>
                        )}
                    </div>
                  </>
                )}
              </div>
            </>
          </div>
        </div>
      </div>
      {detail && (
        <ModalDetail
          detail={detail}
          modalIsOpen={modalIsOpen}
          closeModal={closeModal}
        />
      )}
      </div>
    </>
  );
};

export default injectIntl(Favorites);
